import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getCustomersWithDates = (
    token: string, 
    backend: string, 
    startDate?: string, 
    endDate?: string,
    ) => {
    return fetch(`${getApiUrl(backend)}get_customers_with_dates/${startDate}/${endDate}`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getCustomersWithDates